import { Tabs } from "@mantine/core";
import classes from "../../pages/Trips/Trips.module.css";

const AllPolicyNav = ({ allowedTabs, tabValue, onTabChange }) => (
  <Tabs variant="none" value={tabValue} onChange={onTabChange}>
    <Tabs.List className={classes.list}>
      {allowedTabs.map((tab) => (
        <Tabs.Tab key={tab.value} value={tab.value} className={classes.tab}>
          {tab.label}
        </Tabs.Tab>
      ))}
    </Tabs.List>
  </Tabs>
);

export default AllPolicyNav;
